/* eslint-disable */
import { MessageBox, Loading } from 'element-ui';
import { unary } from './grpc';

const loadingCache = [];
let loading = null;

var remakeerr = (servicemethod, e) => {
    if (e.message.indexOf('Duplicate entry') !== -1) {
        e.message = '记录已存在';
    }
    if (e.message.indexOf('no rows in result set') !== -1) {
        e.message = '记录不存在';
    }
    if (e.message.indexOf('No access token') !== -1) {
        e.message = '未找到授权的小程序, 请稍后再试';
    }
    if (e.message.indexOf('Response closed without headers') !== -1) {
        e.message = '网络错误, 请刷新页面';
    }
    if (e.message.indexOf("Data too long for column 'Image'") !== -1 || e.message.indexOf("Data too long for column 'Logo'") !== -1) {
        e.message = '图片文件名太长, 请将文件名改短后再上传';
    }
    if((servicemethod == 'StoreProductService.UpdateProduct' || servicemethod == 'StoreProductService.CreateProduct') && e.message.indexOf("Assertion failed") !== -1){
        e.message = '价格必须为数字, 可以填0代表不生效';
    }
    return e;
}

export const rpc = (servicemethod, message) => {
  if (loadingCache.length === 0) {
    loading = Loading.service({ text: '请求中...', background: '#fff', target: '#sansanll-content' });
  }
  loadingCache.push(1);

  return unary(servicemethod, message)
    .then(records => {
      setTimeout(() => {
        loadingCache.pop();
        if (loadingCache.length === 0) {
          loading.close();
        }
      }, 500);
      return records;
    })
    .catch(e => {
        if(window.debug){
            console.log(servicemethod, message, e);
        }
      if (e.message === '未认证') {
        window.location.href = '/#/signin';
        return;
      }
      e = remakeerr(servicemethod, e);
      MessageBox({ message: e.message, type: 'error' });

      setTimeout(() => {
        loadingCache.pop();
        if (loadingCache.length === 0) {
          loading.close();
        }
      }, 500);
      throw new Error(e);
    });
};
export const rpc1 = (servicemethod, message) => {
  return unary(servicemethod, message)
    .then(records => {
      return records;
    })
    .catch(e => {
        if(window.debug){
            console.log(servicemethod, message, e);
        }
      if (e.message === '未认证') {
        window.location.href = '/#/signin';
        return;
      }
      e = remakeerr(servicemethod, e);
      MessageBox({ message: e.message, type: 'error' });
      throw new Error(e);
    });
};
